module.exports = __webpack_public_path__ + "assets/img/logitech-becomethenextcreator.b42082e0.webp";